import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(content)/events/page.js")